import { Box, Grid, Skeleton, styled } from '@mui/material'
import { ReactNode } from 'react'
import { useDoubleBookingContext } from '../../hooks'
import { AlertHearingAidEvaluationAlreadyCompleted } from './AlertHearingAidEvaluationAlreadyCompleted'
import { AlertHearingAidEvaluationAlreadyScheduled } from './AlertHearingAidEvaluationAlreadyScheduled'

interface Props {
  children: ReactNode
  isLoading?: boolean
}

const Container = styled(Box)`
  margin: 0 auto;
  place-self: center;
`

const ScheduleContent = ({ children, isLoading: isLoadingTmp = false }: Props) => {
  const {
    hasConfirmedHearingAidEvaluation,
    isHearingAidEvaluationEnabled: isHearingAidEvaluationContext,
    isLoading: isDoubleBookingLoading,
  } = useDoubleBookingContext()

  const isLoading = isLoadingTmp || isDoubleBookingLoading

  if (isLoading) {
    return (
      <>
        <Grid item xs={12} md={4} minHeight="22rem">
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Grid>
        <Grid item xs={12} md={4} minHeight="22rem">
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Grid>
      </>
    )
  }

  if (isHearingAidEvaluationContext) {
    return <>{children}</>
  }

  if (hasConfirmedHearingAidEvaluation) {
    return (
      <Container>
        <AlertHearingAidEvaluationAlreadyScheduled />
      </Container>
    )
  }

  return (
    <Container>
      <AlertHearingAidEvaluationAlreadyCompleted />
    </Container>
  )
}

export { ScheduleContent }
